import {
  BALANCE,
  ERROR,
  LOADING,
  SIGNIN,
  SIGNUP,
  LOAD,
  LOGOUT
} from '../actions';
import * as Helpers from '../../helpers';

export const initialState = {
  balance: 0,
  email: '',
  error: '',
  id: 0,
  loading: [],
  username: '',
};

export default function (state = initialState, action) {
  const { loading } = state;
  const { payload } = action;
  switch (action.type) {
  case LOADING:
    return {
      ...state,
      loading: loading.some(item => item === payload)
        ? loading.filter(item => item !== payload)
        : [...loading, payload],
    };
  case LOGOUT:
    Helpers.token.remove();
    return {
      ...state,
      balance: 0,
      email: '',
      error: '',
      id: 0,
      loading: [],
      username: '',
    };
  case LOAD:
    return {
      ...state,
      balance: payload.data.balance,
      email: payload.data.email,
      id: payload.data.id,
      username: payload.data.username,
    };
  case SIGNIN:
    Helpers.notification.success(payload.message);
    Helpers.token.set(payload.data.token);
    return {
      ...state,
      balance: payload.data.balance,
      email: payload.data.email,
      id: payload.data.id,
      username: payload.data.username,
    };
  case SIGNUP:
    Helpers.notification.success(payload.message);
    return {
      ...state,
      balance: payload.data.balance,
      email: payload.data.email,
      id: payload.data.id,
      username: payload.data.username,
    };
  case BALANCE:
    Helpers.notification.success(payload.message);
    return {
      ...state,
      balance: payload.data.balance,
    };
  case ERROR:
    Helpers.notification.error(payload || 'An error occurred.');
    return {
      ...state,
      error: payload || 'An error occurred.',
    };
  default:
    return state;
  }
}
